module.exports = __webpack_public_path__ + "img/wqjn_icon_4.png";